<!--模板-->
<template>
  <div id="homePage">
    <!-- **banner背景图 -->
    <div class="banner_img" v-if="  getUserData.user && getUserData.user.photoWall" :style="getUserData && getUserData.user.photoWall.length > 0 ?'background:url('+getUserData.user.photoWall[0]+') repeat;background-size: contain' : 'b'">
      <img v-if="getUserData.user.photoWall.length == 0" :src="getUserData.user.avatar" alt="" />
    </div>
    <div class="homePage_content" v-if="getUserData.user">
      <!-- ***导游概述 -->
      <div class="sec_guide_desc mid clearfix">
        <div class="guide-imge fl">
          <a><img :src="getUserData.user.avatar" height="320" width="320" /></a>
        </div>
        <div class="guide-cont fr">
          <div class="lt-ct fl">
            <div class="name">
              <em class="n1">{{ getUserData.user.nickname }}</em>
              <em>{{ getUserData.gender == 2 ? "（女）" : "（男）" }}
                <i>{{
                  getUserData.dateBirthStr
                    ? getUserData.dateBirthStr + "岁"
                    : ""
                }}</i>
              </em>
              <em>
                <i>{{ getUserData.constellationStr }}</i>
              </em>
            </div>
            <div class="addr" v-if="getUserData.user && getUserData.user.homeCity">
              <em class="a1">现居：{{ getUserData.user.homeCity.province.label || "未设置" }}•{{
                  getUserData.user.homeCity.city.label
                }}</em>
              <em class="a2">来自：{{ getUserData.user.hometown.province.label || "未设置" }}•{{
                  getUserData.user.hometown.city.label
                }}</em>
              <em>情感：{{ getUserData.user.emotion }}</em>
            </div>
            <div class="lang">
              语言能力：<a>{{ getUserData.user.language || "未设置" }}</a>
            </div>
            <div class="lang">
              个人标签：<a>{{ getUserData.user.label || "未设置" }}</a>
            </div>
          </div>
          <div class="rt-ct fr">
            <!--<div class="serv">下单量：<b>53</b>/次</div>-->
            <div class="cmts">
              <em>好评率：<b>100%</b></em>
              <em>服务<b>100%</b></em>
              <em>颜值：<b>9.9</b></em>
            </div>
            <div class="care fl">
              <span class="c1 fl">点赞：<a href="#"><b>0</b>次</a></span>
              <span class="c2 fr">关注：<a href="#"><b>0</b>人</a></span>
            </div>
          </div>
          <div class="ft-ct ">
            <label v-if="
                getUserData &&
                  getUserData.proofs &&
                  getUserData.proofs.proofImgPath != ''
              ">身份证认证<br /><em>已认证</em></label>
            <label v-if="
                getUserData &&
                  getUserData.proofs &&
                  getUserData.proofs.guideImgPath != ''
              ">导游证认证<br /><em>已认证</em></label>
            <label v-if="
                getUserData &&
                  getUserData.proofs &&
                  getUserData.proofs.userImgPath != ''
              ">形象照认证<br /><em>已认证</em></label>
            <!--<label>相册认证<br /><em>已认证</em></label>-->
            <!--<label>旅途认证<br /><em>已认证</em></label>-->
            <!--<label>资质认证<br /><em>已认证</em></label>-->
          </div>
        </div>
      </div>
      <!-- ***导游详细展示 -->
      <div class="sec_guide_container pb--50 mid clearfix clear">
        <!--左侧-->
        <div class="lay-gd-main fl">
          <ul class="nav clearfix">
            <li :class="tabIndex == 0 ? 'on' : ''" @click="tabBtn(0)">
              <a>我的介绍</a>
            </li>
            <li :class="tabIndex == 1 ? 'on' : ''" @click="tabBtn(1)">
              <a>我的故事</a>
            </li>
            <li :class="tabIndex == 2 ? 'on' : ''" @click="tabBtn(2)">
              <a>我的旅图</a>
            </li>
            <li :class="tabIndex == 4 ? 'on' : ''" @click="tabBtn(4)">
              <a>预订须知</a>
            </li>
            <li :class="tabIndex == 3 ? 'on' : ''" @click="tabBtn(3)">
              <a>服务标准</a>
            </li>
            <li :class="tabIndex == 5 ? 'on' : ''" @click="tabBtn(5)">
              <a>用户点评</a>
            </li>
          </ul>
          <!--我的介绍-->
          <div class="i-summary" v-show="tabIndex == 0">
            <h2 class="hd">我的介绍</h2>
            <div class="ct">
              <p>{{ getUserData.user.introduce || "Ta很懒,还没介绍自己~" }}</p>
            </div>
          </div>
          <div class="i-photo mt--30" v-if=" tabIndex == 0   ">
            <h2 class="hd">个人相册</h2>
            <div style="width: 100%;padding: 10px" v-if="getUserData && getUserData.user && getUserData.user.photoWall">
              <el-carousel :interval="4000" type="card" height="300px">
                <el-carousel-item v-for="(item, index) of getUserData.user.photoWall" :key="index">
                  <img :src="item" @click="imgSet(item)" style="width:100%" />
                </el-carousel-item>
              </el-carousel>
            </div>
            <!--<div class="photo-ct">-->
            <!--<div id="featured-area">-->
            <!--<ul class="roundabout-holder">-->
            <!--<li class="roundabout-moveable-item" v-for="item in getUserData.photoWall.imgPath.split(',')" :key="item"><a  ><img :src="item" /></a></li>-->
            <!--</ul>-->
            <!--</div>-->
            <!--</div>-->
          </div>
          <!--我的故事-->
          <div class="i-summary" v-if="tabIndex == 1">
            <h2 class="hd">我的故事</h2>
            <div class="ct">
              <p>
                {{ getUserData.user.story || "Ta很懒,还没写自己的故事~" }}
              </p>
            </div>
          </div>
          <!--我的相册-->
          <div class="i-trip-photo" v-if="tabIndex == 2">
            <h2 class="hd">我的旅图</h2>
            <div class="Photo">
              <ul>
                <li v-for="(item, index) of getUserData.photoList" :key="index" style="display: inline-block">
                  <img style="width: 200px;height: 200px;padding: 10px" :src="item.imgPath" @click="imgSet(item)" alt="" />
                </li>
                <li v-if="getUserData.photoList.length == 0" style="font-size: 16px">
                  暂无照片集
                </li>
              </ul>
            </div>
          </div>
          <!--用户点评-->
          <div class="i-ls-cmts" v-if="tabIndex == 5">
            <h2 class="hd">用户点评</h2>
            <div class="cmts-ct">
              <div class="whole_score">
                <div class="rate fl">
                  整体评分：<span><b class="c--f60">5.0</b>/5分</span>
                </div>
                <div class="actor_new fl">
                  <dl>
                    <dt>大家都在说：</dt>
                    <dd>
                      <span>服务不错</span>
                      <span>响应快</span>
                      <span>很开心</span>
                      <span>彬彬有礼</span>
                    </dd>
                  </dl>
                </div>
              </div>
              <div class="u-ls-comments mt--20">
                <!-- //排序条-->
                <div class="ls-zone-order">
                  <div class="order-bar clearfix-container">
                    <!--<span class="fl"><a>全部</a></span>-->
                    <!--<span class="fl"><a class="on">用户评价</a></span>-->
                  </div>
                  <!--<div class="order-type">-->
                  <!--<select class="selectSort" name="order">-->
                  <!--<option value="">默认排序</option>-->
                  <!--<option value="2134">按价格从高到低</option>-->
                  <!--<option value="5231">按价格从低到高</option>-->
                  <!--<option value="5231">按销量</option>-->
                  <!--<option value="5231">按人气</option>-->
                  <!--</select>-->
                  <!--</div>-->
                  <!--<script type="text/javascript">
                    -- >
                    <!--//排序选择-->
                  <!--$(".selectSort").searchableSelect();-->
                  <!--
                    </script>-->
                </div>
                <!-- //用户评价-->
                <div class="user-comments-container">
                  <ul class="user-comments-list clearfix">
                    <!--                    <li class="items">-->
                    <!--                      <div class="dib vat user-name">-->
                    <!--                        <img src="../../../static/images/guide/wx-guide-img-235x210.jpg" width="65" height="65"><br>WX_**熊**-->
                    <!--                      </div>-->
                    <!--                      <div class="dib vat comments-content">-->
                    <!--                        <div class="h pos-rel">-->
                    <!--                          <span class="notch pos-abs"><b class="cc"></b><b class="cb"></b></span>-->
                    <!--                          <div class="score dib"><i style="width: 50%">&lt;!&ndash; 评分：100% 五心 &ndash;&gt;</i></div>-->
                    <!--                          <b class="comment-date pos-abs">2016-03-21 16:24:45</b>-->
                    <!--                        </div>-->
                    <!--                        <div class="type-show clearfix">-->
                    <!--                          <div class="cc fl">-->
                    <!--                            <p class="show-pic-desc">如果你看过《恋战冲绳》的电影，那么你一定对有着如此湛蓝海水的冲绳记忆深刻。冲绳离上海飞机不过短短 2个小时就可到达，即适合疯狂购物游，也适合带着家人一起去海边享受蓝天白云的慵懒假期...</p>-->
                    <!--                            <ul class="show-pic-container clearfix">-->
                    <!--                              <li class="fl"><a href="#" target="_blank"><img src="../../../static/images/guide/bx-img1-235x150.jpg" width="101" alt=""></a></li>-->
                    <!--                            </ul>-->
                    <!--                            <p class="show-addr">香港2晚 3日双园游</p>-->
                    <!--                          </div>-->
                    <!--                        </div>-->
                    <!--                      </div>-->
                    <!--                    </li>-->
                    <!--                    <li class="items">-->
                    <!--                      <div class="dib vat user-name">-->
                    <!--                        <img src="../../../static/images/guide/guide-thumb-img1.jpg" width="65" height="65"><br>WX_**熊**-->
                    <!--                      </div>-->
                    <!--                      <div class="dib vat comments-content">-->
                    <!--                        <div class="h pos-rel">-->
                    <!--                          <span class="notch pos-abs"><b class="cc"></b><b class="cb"></b></span>-->
                    <!--                          <div class="score dib"><i style="width: 100%">&lt;!&ndash; 评分：100% 五心 &ndash;&gt;</i></div>-->
                    <!--                          <b class="comment-date pos-abs">2016-01-12 16:24:45</b>-->
                    <!--                        </div>-->
                    <!--                        <div class="type-show clearfix">-->
                    <!--                          <div class="cc fl">-->
                    <!--                            <p class="show-pic-desc">看盡 瑞士 的美要多久？ 一個月 ······不夠 忘記 瑞士 的美要多久？ 一生 ······也不夠 很少的东西，一无所有驱逐 丧失空间的畏惧 留给流浪的灵魂 但或许，灵魂更轻盈 不确定它的持续 难道是它在歌唱...</p>-->
                    <!--                            <ul class="show-pic-container clearfix">-->
                    <!--                              <li class="fl"><a href="#" target="_blank"><img src="../../../static/images/placeholder/world-city-img1-235x235.jpg" width="101" alt=""></a></li>-->
                    <!--                              <li class="fl"><a href="#" target="_blank"><img src="../../../static/images/placeholder/world-city-img2-235x235.jpg" width="101" alt=""></a></li>-->
                    <!--                              <li class="fl"><a href="#" target="_blank"><img src="../../../static/images/placeholder/world-city-img3-235x235.jpg" width="101" alt=""></a></li>-->
                    <!--                              <li class="fl"><a href="#" target="_blank"><img src="../../../static/images/placeholder/world-city-img4-235x235.jpg" width="101" alt=""></a></li>-->
                    <!--                              <li class="fl"><a href="#" target="_blank"><img src="../../../static/images/placeholder/world-city-img5-235x235.jpg" width="101" alt=""></a></li>-->
                    <!--                            </ul>-->
                    <!--                            <p class="show-addr">香港2晚 3日双园游</p>-->
                    <!--                          </div>-->
                    <!--                        </div>-->
                    <!--                      </div>-->
                    <!--                    </li>-->
                    <!--                    <li class="items">-->
                    <!--                      <div class="dib vat user-name">-->
                    <!--                        <img src="../../../static/images/guide/wx-guide-img-235x210.jpg" width="65" height="65"><br>WX_**熊**-->
                    <!--                      </div>-->
                    <!--                      <div class="dib vat comments-content">-->
                    <!--                        <div class="h pos-rel">-->
                    <!--                          <span class="notch pos-abs"><b class="cc"></b><b class="cb"></b></span>-->
                    <!--                          <div class="score dib"><i style="width: 80%">&lt;!&ndash; 评分：100% 五心 &ndash;&gt;</i></div>-->
                    <!--                          <b class="comment-date pos-abs">2015-09-21 16:24:45</b>-->
                    <!--                        </div>-->
                    <!--                        <div class="type-show clearfix">-->
                    <!--                          <div class="cc fl">-->
                    <!--                            <p class="show-pic-desc">2016年01月31日，我向自己预约了这篇游记，当时我说： 2月10日-2月14日， 我计划去 拉萨 。 出发前，我敲下了这些文字： 西藏 ，一生必去一次的地方。 乔治•马洛里在被问起，为何要去攀登 珠穆朗玛峰 ？</p>-->
                    <!--                            <ul class="show-pic-container clearfix">-->
                    <!--                              <li class="fl"><a href="#" target="_blank"><img src="../../../static/images/guide/bx-img1-235x150.jpg" width="101" alt=""></a></li>-->
                    <!--                            </ul>-->
                    <!--                            <p class="show-addr">香港2晚 3日双园游</p>-->
                    <!--                          </div>-->
                    <!--                        </div>-->
                    <!--                      </div>-->
                    <!--                    </li>-->
                    <h4 style="font-size:20px;padding:50px 0;text-align:center">
                      暂无评价
                    </h4>
                  </ul>
                </div>
              </div>
              <!-- //发表评价-->
              <!--              <div class="publish_cmts">-->
              <!--                <div class="cmts-main">-->
              <!--                  <h2>发表评价</h2>-->
              <!--                  <textarea name="contents"></textarea>-->
              <!--                  <a class="btn-publish" href="javascript:;">发 布</a>-->
              <!--                </div>-->
              <!--              </div>-->
            </div>
          </div>
          <!--服务标准-->
          <div class="i-summary" v-if="tabIndex == 3">
            <h2 class="hd">服务标准</h2>
            <div class="ct">
              <p>1、热情、周到、细致的服务精神，提供全方位的优质服务。</p>
              <p>
                2、服务前认真熟悉服务计划及服务事宜，风趣幽默的落实服务客人。
              </p>
              <p>
                3、向客人详细介绍本次服务的安排、注意事项。（使用礼貌用语，热情服务，关心客人，及时为客人提供便利及需要。讲解内容要丰富、生动、有趣，并根据客人的兴趣随时调整话题。）
              </p>
              <p>
                4、线下服务的坚持三不原则：不私自增加约定行程之外的其他消费点；不推荐客人进入非法性的消费场所；不私自带客人进入收取回佣的购物店。
              </p>
              <p>
                5、线下服务的服务当天，及时和客人联系确认出发时间及行程安排，
                提前30分钟到达指定的地点。
              </p>
            </div>
          </div>
          <!--预定须知-->
          <div class="i-summary" v-if="tabIndex == 4">
            <h2 class="hd">预订须知</h2>
            <div class="ct">
              <p>
                1.为避免您预订的时间与其他客户预定的时间有冲突，请及时下单,下订单后我将根据您的时间，为您及时安排日程。
              </p>
              <p>
                2.服务工作时间以个人来定（通常为9小时工作制）为准，具体可询问双方，若需提前或延长或特殊情况，请提前告知协商。
              </p>
              <p>
                3.请仔细阅读服务详情、服务事项、包含项及不包含项，以免造成不必要的麻烦。
              </p>
              <p>
                4.成功预订并下单后，我会及时联系您进行沟通，请保持电话畅通。
              </p>
              <p>5.线下服务的，为保证您的行程顺利进行，请尽量提前1天预定。</p>
              <p>
                6.因特殊情况原因，不能进行服务时，未进行的订单将取消订单，进行中的订单将双方协商取消。
              </p>
              <p>
                7.因战争、政变、罢工、天气、交通延阻、飞机故障、航班取消或更改时间等不可抗力原因所引致的额外费用将不承担。
              </p>
            </div>
          </div>
          <!--我提供的服务-->
          <div class="i-play-serv mt--50">
            <h2 class="hd">我提供的（技能服务）</h2>
            <div class="playServ-ct">
              <ul class="js-iService">
                <li v-for="(item, index) of Serves" :key="index" @click="servesBtn(item.code)">
                  <!-- <em class="tag"><i>￥{{item.pushPrice}}元/{{item.servePriceName}}</i></em> -->
                  <a class="img" href="javascript:;"><img :src="item.serveCoverImg" height="220" width="270" /></a>
                  <div class="serv">
                    <a class="uimg" href="#"><img :src="getUserData.headImg" height="36" width="36" /></a>
                    <h2>{{ item.title }}</h2>
                    <h4>{{ item.pushTypeStr }}</h4>
                    <!-- <label>￥{{item.pushPrice}}元/{{item.servePriceName}}</label> -->
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!--我的旅行心愿-->
          <div class="i-play-serv mt--30">
            <h2 class="hd">我的（心愿愿望）</h2>
            <div class="playServ-dy">
              <div class="lay-zone-cont2">
                <div class="jd-hotList-main mid--1000">
                  <ul>
                    <li v-for="(item, index) of TravelList.data" :key="index" @click="TravelBtn(item.code)">
                      <em class="tag" v-if="item.thankMethod != 0"><i>{{
                          item.thankMethod == 1
                            ? "代购"
                            : item.thankMethod == 2
                            ? "抽奖"
                            : item.thankMethod == 3
                            ? "代购+抽奖"
                            : ""
                        }}</i></em>
                      <a class="img"><img :src="
                            item.travelImg != null
                              ? item.travelImg.split(',')[0]
                              : ''
                          " height="250" width="320" /></a>
                      <div class="spot_desc">
                        <div class="addr clearfix">
                          <label class="fl">{{ item.title }}</label>
                          <a class="fr">详情»</a>
                        </div>
                        <div class="nums">
                          <em class="e1">已获 {{ item.travelMappingMoney }}元</em>
                          <em class="e3">愿望 {{ item.travelMoney }}元</em>
                        </div>
                      </div>
                      <p style="padding: 10px">
                        <el-progress :text-inside="true" :stroke-width="18" :percentage="
                            item.travelMoney > item.travelMappingMoney
                              ? Math.floor(
                                  (item.travelMappingMoney / item.travelMoney) *
                                    100
                                )
                              : 100
                          "></el-progress>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--右侧-->
        <div class="lay-gd-side fr">
          <div class="i-service">
            <!-- <h2 class="hd">下单预定</h2> -->
            <div class="service-ct clearfix" style="display:none">
              <ul class="clearfix" style="display:none">
                <li>
                  <label>服务开始</label>
                  <el-date-picker v-model="startTime" value-format="timestamp" type="date" @change="startTimeBtn" style="width: 150px" placeholder="开始日期">
                  </el-date-picker>
                  <!--<input class="ipt-text start_timepicker" name="start_time" type="text" placeholder="年-月-日" />-->
                </li>
                <li>
                  <label>结束时间</label>
                  <el-date-picker v-model="endTime" value-format="timestamp" type="date" @change="endTimeBtn" style="width: 150px" placeholder="结束日期">
                  </el-date-picker>
                  <!--<input class="ipt-text end_timepicker" name="end_time" type="text" placeholder="年-月-日" />-->
                </li>
                <li class="last">
                  <label>人数</label>
                  <select name="peopleNuhm" v-model="nameNumber">
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                  </select>
                </li>
              </ul>
              <!-- ###删除
                                <div class="my-serv">
                                    <h2>我添加的服务</h2>
                                    <div class="ct">
                                        <span><a class="pickup" href="#">厦门北站接送【随叫随到】</a>，2016-01-02~2016-01-07 王琳琳，￥<b>150</b>元/天</span>
                                        <a class="close"></a>
                                    </div>
                                </div>
                                -->
              <div class="btn-bookNow">
                <a class="transit js-bookNow" @click="serviceBtn(2)">立即预订</a>
              </div>
              <div class="process">
                <span><i>1</i>提交预订申请</span>
                <span><i>2</i>等待陪陪处理</span>
                <span><i>3</i>支付费用</span>
                <span><i>4</i>服务进行开始</span>
              </div>
            </div>
            <!-- //我的服务档期-->
            <!--<div class="serv-date" style="margin:30px auto 0;">-->
            <!--<h2 style="background:#eee;border:1px solid #ddd;color:#333;font-size:16px;font-weight:700;margin:0 0 -1px 9px;text-align:center;height:40px;line-height:40px;width:340px;">我的服务档期</h2>-->
            <!--<div id="CalendarMain">-->
            <!--<div id="title"><a class="selectBtn month" href="javascript:" onclick="CalendarHandler.CalculateLastMonthDays();">&lt;</a><a class="selectBtn selectYear" href="javascript:" onclick="CalendarHandler.CreateSelectYear(CalendarHandler.showYearStart);">2016年</a><a class="selectBtn selectMonth" onclick="CalendarHandler.CreateSelectMonth()">5月</a> <a class="selectBtn nextMonth" href="javascript:" onclick="CalendarHandler.CalculateNextMonthDays();">&gt;</a><a class="selectBtn currentDay" href="javascript:" onclick="CalendarHandler.CreateCurrentCalendar(0,0,0);" style="display: none; ">今天</a></div>-->
            <!--<div id="context">-->
            <!--<div class="week">-->
            <!--<h3>一</h3><h3>二</h3><h3>三</h3><h3>四</h3><h3>五</h3><h3>六</h3><h3>日</h3>-->
            <!--</div>-->
            <!--<div id="center">-->
            <!--<div id="centerMain">-->
            <!--<div id="selectYearDiv"></div>-->
            <!--<div id="centerCalendarMain">-->
            <!--<div id="Container"></div>-->
            <!--</div>-->
            <!--<div id="selectMonthDiv"></div>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <!-- //广告位-->
            <div class="serv-advert mt--30">
              <a><img src="../../../static/images/placeholder/pos-serv-advert-img.jpg" width="345" /></a>
            </div>
          </div>
        </div>
        <!--服务详情-->
        <template v-if="serviceShow">
          <el-dialog title="技能服务详情" :visible.sync="serviceShow" width="80%" center>
            <div class="service_bg">
              <!--轮播图-->
              <div class="img_list" v-if="servesData.images.length != 0">
                <el-carousel :interval="4000" type="card" height="200px">
                  <el-carousel-item v-for="(item, index) in servesData.images" :key="index">
                    <img style="width: 100%;height: 100%" :src="item" alt="" />
                  </el-carousel-item>
                </el-carousel>
              </div>
              <!-- <div   style="text-align: center;font-weight: bold;font-size: 25px;padding:50px 0;">[{{servesData.pushTypeStr}}] : {{servesData.title}} <span style="float: right;color: #f60;font-weight: bold;font-size: 20px;border: 1px solid #f60;padding: 3px 10px">￥{{servesData.pushPrice}}元 / {{servesData.servePriceName}}</span></div> -->
              <!--切换-->
              <div class="tab_bg">
                <span :class="serviceTab == 0 ? 'tab_Sel' : ''" @click="serviceTab = 0">服务内容</span>
                <span :class="serviceTab == 1 ? 'tab_Sel' : ''" @click="serviceTab = 1">Ta的评价</span>
              </div>
              <!--服务内容-->
              <div v-show="serviceTab == 0">
                <table style="table-layout: inherit" v-if="servesData">
                  <tr>
                    <td>服务费用</td>
                    <td>
                      ￥{{ servesData.province }}元 /
                      {{ servesData.priceTypeText }}
                    </td>
                  </tr>
                  <tr>
                    <td>服务类型</td>
                    <td>{{ servesData.typeText }} 服务</td>
                  </tr>
                  <tr>
                    <td>服务方式</td>
                    <td>
                      <span v-for="(item,index) of servesData.mode" :key="index">[{{item}}]</span>
                    </td>
                  </tr>
                  <tr>
                    <td>服务群体</td>
                    <td>一对一服务</td>
                  </tr>
                  <tr>
                    <td>服务时间</td>
                    <td>
                      <span v-for="(item,index) of servesData.serviceTime" :key="index">[{{item}}]</span>
                    </td>
                  </tr>
                  <tr>
                    <td>服务位置</td>
                    <td>不限</td>
                  </tr>
                  <tr>
                    <td>服务详情</td>
                    <td>
                      <br />
                      <div v-html="servesData.content" class="dHtml"></div>
                      <br />
                    </td>
                  </tr>
                  <tr>
                    <td>费用包含</td>
                    <td>
                      {{ servesData.contain || "无" }}
                      <!--                      <p v-for="(item,index) of servesData.servePrice" :key="index">{{item.unitName}}：{{item.price}}元</p>-->
                    </td>
                  </tr>
                  <tr>
                    <td>费用不包含</td>
                    <td>{{ servesData.notContain || "无" }}</td>
                  </tr>
                  <tr>
                    <td>补充说明</td>
                    <td>{{ servesData.supplement || "无" }}</td>
                  </tr>
                  <tr>
                    <td>预订须知</td>
                    <td>
                      <p>
                        1.为避免您预订的时间与其他客户预定的时间有冲突，请及时下单,下订单后我将根据您的时间，为您及时安排日程。
                      </p>
                      <p>
                        2.服务工作时间以个人来定（通常为9小时工作制）为准，具体可询问双方，若需提前或延长或特殊情况，请提前告知协商。
                      </p>
                      <p>
                        3.请仔细阅读服务详情、服务事项、包含项及不包含项，以免造成不必要的麻烦。
                      </p>
                      <p>
                        4.成功预订并下单后，我会及时联系您进行沟通，请保持电话畅通。
                      </p>
                      <p>
                        5.线下服务的，为保证您的行程顺利进行，请尽量提前1天预定。
                      </p>
                      <p>
                        6.因特殊情况原因，不能进行服务时，未进行的订单将取消订单，进行中的订单将双方协商取消。
                      </p>
                      <p>
                        7.因战争、政变、罢工、天气、交通延阻、飞机故障、航班取消或更改时间等不可抗力原因所引致的额外费用将不承担。
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>服务标准</td>
                    <td>
                      <p>
                        1、热情、周到、细致的服务精神，提供全方位的优质服务。
                      </p>
                      <p>
                        2、服务前认真熟悉服务计划及服务事宜，风趣幽默的落实服务客人。
                      </p>
                      <p>
                        3、向客人详细介绍本次行程的安排、注意事项。（使用礼貌用语，热情服务，关心客人，及时为客人提供便利及需要。讲解内容要丰富、生动、有趣，并根据客人的兴趣随时调整话题。）
                      </p>
                      <p>
                        4、线下服务的坚持三不原则：不私自增加约定行程之外的其他消费点；不推荐客人进入非法性的消费场所；不私自带客人进入收取回佣的购物店。
                      </p>
                      <p>
                        5、线下服务的服务当天，及时和客人联系确认出发时间及行程安排，
                        提前30分钟到达指定的地点。
                      </p>
                    </td>
                  </tr>
                </table>

                <div style="text-align:center;margin:20px 0;">
                  <p>
                    <span style="color: #f60;font-weight: bold;font-size: 20px;padding: 3px 10px">注：不提供在线付款功能，请直接微信预约该用户</span>
                  </p>
                </div>
                <div style="text-align:center">
                  <el-button type="primary" @click="liwuShow = true">微信预约</el-button>
                </div>

                <div class="reserve" style="display:none">
                  <div>
                    <el-date-picker v-model="startTimeData" type="datetimerange" range-separator="至" @change="TimeDataBtn" start-placeholder="开始日期" value-format="timestamp" format="yyyy-MM-dd HH:mm" :default-time="['18:00:00', '23:59:59']" end-placeholder="结束日期">
                    </el-date-picker>
                    <!--<el-date-picker-->
                    <!--v-model="startTime"-->
                    <!--type="date"-->
                    <!--placeholder="开始日期">-->
                    <!--</el-date-picker>-->
                    <!--</div>-->
                    <!--&#45;&#45;-->
                    <!--<div>-->
                    <!--<el-date-picker-->
                    <!--v-model="endTime"-->
                    <!--type="date"-->
                    <!--placeholder="结束日期">-->
                    <!--</el-date-picker>-->
                  </div>
                  <div style="padding: 0 5px 0 20px">
                    人数
                  </div>
                  <div>
                    <el-input-number v-model="nameNumber" @change="handleChange" :min="1" :max="10" label="人数"></el-input-number>
                  </div>
                  <div style="padding-left: 20px">
                    <el-button type="primary" @click="serviceBtn(1)">立即预订</el-button>
                  </div>
                  <p>
                    <span style="color: #f60;font-weight: bold;font-size: 20px;padding: 3px 10px">(￥{{ servesData.pushPrice }}元/{{
                        servesData.servePriceName
                      }})</span>
                  </p>
                </div>
              </div>
              <!--评价-->
              <div style="width: 100%" v-show="serviceTab == 1">
                <div class="user-comments-container">
                  <ul class="user-comments-list clearfix" v-if="InfoData">
                    <li class="items" v-for="(item, index) of InfoData.data" :key="index">
                      <div class="dib vat user-name">
                        <img :src="item.userInfo.headImg" width="65" height="65" /><br />{{ item.userInfo.name }}
                      </div>
                      <div class="dib vat comments-content">
                        <div class="h pos-rel">
                          <span class="notch pos-abs"><b class="cc"></b><b class="cb"></b></span>
                          <div class="score dib">
                            <i :style="
                                'width:' + (Number(item.remake1) + 5) + '0%'
                              ">
                              <!-- 评分：100% 五心 -->
                            </i>
                          </div>
                          <b class="comment-date pos-abs">{{
                            item.createTime | GetTime
                          }}</b>
                        </div>
                        <div class="type-show clearfix">
                          <div class="cc fl">
                            <p class="show-pic-desc">{{ item.text }}</p>
                            <!-- <ul class="show-pic-container clearfix">
                                      <li class="fl"><a href="#" target="_blank"><img src="../../../static/images/guide/bx-img1-235x150.jpg" width="101" alt=""></a></li>
                                    </ul>
                                    <p class="show-addr">香港2晚 3日双园游</p> -->
                          </div>
                        </div>
                      </div>
                    </li>
                    <li v-if="InfoData.data == null" style="font-size:20px;padding:50px 0;text-align:center">
                      暂无评价
                    </li>
                    <!--                    <li class="items">-->
                    <!--                      <div class="dib vat user-name">-->
                    <!--                        <img src="../../../static/images/guide/wx-guide-img-235x210.jpg" width="65" height="65"><br>WX_**熊**-->
                    <!--                      </div>-->
                    <!--                      <div class="dib vat comments-content">-->
                    <!--                        <div class="h pos-rel">-->
                    <!--                          <span class="notch pos-abs"><b class="cc"></b><b class="cb"></b></span>-->
                    <!--                          <div class="score dib"><i style="width: 80%">&lt;!&ndash; 评分：100% 五心 &ndash;&gt;</i></div>-->
                    <!--                          <b class="comment-date pos-abs">2015-09-21 16:24:45</b>-->
                    <!--                        </div>-->
                    <!--                        <div class="type-show clearfix">-->
                    <!--                          <div class="cc fl">-->
                    <!--                            <p class="show-pic-desc">2016年01月31日，我向自己预约了这篇游记，当时我说： 2月10日-2月14日， 我计划去 拉萨 。 出发前，我敲下了这些文字： 西藏 ，一生必去一次的地方。 乔治•马洛里在被问起，为何要去攀登 珠穆朗玛峰 ？</p>-->
                    <!--                            <ul class="show-pic-container clearfix">-->
                    <!--                              <li class="fl"><a href="#" target="_blank"><img src="../../../static/images/guide/bx-img1-235x150.jpg" width="101" alt=""></a></li>-->
                    <!--                            </ul>-->
                    <!--                            <p class="show-addr">香港2晚 3日双园游</p>-->
                    <!--                          </div>-->
                    <!--                        </div>-->
                    <!--                      </div>-->
                    <!--                    </li>-->
                  </ul>
                </div>
              </div>
            </div>
            <!--礼物小程序-->
            <el-dialog width="80%" title="打开微信，扫一扫，或下载APP，立即认识Ta~" :visible.sync="liwuShow" append-to-body>
              <div class="liwu_bg">
                <!-- <img style="border-radius:20%;width:425px " src="../../../static/images/index/liwu.png" alt=""> -->
                <img src="../../../static/images/index/we.jpg" alt="" />
                <h3 style="text-align: center;margin: 20px 0;color: #f60">
                  （打开微信，扫一扫小程序码，或下载APP，立即认识Ta~）
                </h3>
              </div>
            </el-dialog>
          </el-dialog>
        </template>

        <!--心愿赞助详情-->
        <template v-if="travelShow">
          <el-dialog title="心愿愿望详情" :visible.sync="travelShow" width="80%" center>
            <div class="littlewish-wrapper" v-if="travelData">
              <div class="littlewish-part1-wrapper">
                <img :src="travelData.travelImg" class="littlewish-part1-img" />
                <div class="littlewish-part1-content">
                  <p class="littlewish-part1-content-txt">
                    旅行愿望：{{ travelData.title }}
                  </p>
                  <p class="littlewish-part1-content-time-wrapper">
                    <span class="iconfont icon-msnui-time"></span><span>{{ travelData.travelStart | GetTime }} ——
                      {{ travelData.travelEnd | GetTime }}</span>
                    <span class="littlewish-part1-content-time">我的心愿我代言~</span>
                  </p>
                </div>
                <!--                <div class="littlewish-part1-footer" v-if="travelData">-->
                <!--                  <div class="littlewish-part1-footer-info">-->
                <!--                    <img :src="travelData.user.headImg" class='littlewish-part1-footer-info-img'/>-->
                <!--                    <span class='littlewish-part1-footer-info-name'>{{travelData.user.name}}</span>-->
                <!--                  </div>-->
                <!--                  &lt;!&ndash;<div class="littlewish-part1-footer-status">&ndash;&gt;-->
                <!--                  &lt;!&ndash;<span class="iconfont icon-weiwancheng"></span>&ndash;&gt;-->
                <!--                  &lt;!&ndash;</div>&ndash;&gt;-->
                <!--                </div>-->
              </div>
              <div class="littlewish-part2-wrapper">
                <div class="littlewish-part2-title-wrapper">
                  <p class="littlewish-part2-title">
                    <span class="littlewish-part2-title-label">心愿主题：</span><span class="littlewish-part2-title-txt globalFontColor">心愿愿望</span>
                  </p>
                  <p class="littlewish-part2-title">
                    <span class="littlewish-part2-title-label">出行人数：</span><span class="littlewish-part2-title-txt globalFontColor">{{ travelData.travelNumber }}人</span>
                  </p>
                </div>
                <div class="littlewish-part2-content">
                  <p class="littlewish-part2-content-label">心愿进度</p>
                  <div class="littlewish-part2-content-progress">
                    <el-progress :text-inside="true" :stroke-width="18" :percentage="
                        travelData.travelMoney > travelData.travelMappingMoney
                          ? Math.floor(
                              (travelData.travelMappingMoney /
                                travelData.travelMoney) *
                                100
                            )
                          : 100
                      "></el-progress>
                  </div>
                  <div class="littlewish-part2-content-status">
                    <p class="littlewish-part2-content-status-item">
                      <span class="littlewish-part2-content-status-item-money globalFontColor">{{ travelData.travelMappingMoney }}(元)</span>
                      <span class="littlewish-part2-content-status-item-label">已获金额(元)</span>
                    </p>
                    <p class="littlewish-part2-content-status-item">
                      <span class="littlewish-part2-content-status-item-money">已赞助</span>
                      <span class="littlewish-part2-content-status-item-label">企业赞助</span>
                    </p>
                    <p class="littlewish-part2-content-status-item">
                      <span class="littlewish-part2-content-status-item-money">{{ travelData.travelMoney }}(元)</span>
                      <span class="littlewish-part2-content-status-item-label">愿望总额(元)</span>
                    </p>
                  </div>
                </div>
                <div class="littlewish-part2-discription">
                  心愿详情：<span v-html="travelData.context"></span>
                </div>
              </div>
              <div class="prize" v-if="travelData.thankMethod != 0">
                <p class="littlewish-part3-label"><span>答谢方式</span></p>
                <p class="littlewish-part2-discription" v-if="
                    travelData.thankMethod == 1 || travelData.thankMethod == 3
                  ">
                  <span>帮忙代购：</span>帮忙代购，赞助者可与我联系，优惠对待！
                </p>
                <p class="littlewish-part2-discription" v-if="
                    travelData.thankMethod == 2 || travelData.thankMethod == 3
                  ">
                  <span>随机抽奖：</span>抽奖截止时间为
                  <span>{{ travelData.travelEnd | GetTime }}</span>，奖品为本人（<span>{{ travelData.goodsName }}</span>），由本人提供，并与时间结束3个工作日内,由本人安排发放！（注：奖品由发布者本人提供）
                </p>
              </div>
              <div class="littlewish-part3-wrapper">
                <p class="littlewish-part3-label">品牌冠名赞助</p>
                <div class="littlewish-part3-item" v-if="travelData.sponsor != null">
                  <div class="littlewish-part3-item-content-img-wrapper">
                    <img :src="travelData.sponsor.headImg" class="littlewish-part3-item-content-img" />
                  </div>
                  <p class="littlewish-part3-item-content" style="padding-top: 50px">
                    {{ travelData.sponsor.name }}
                  </p>
                  <p class="littlewish-part3-item-content">
                    {{ travelData.sponsor.urlContext }}
                  </p>
                  <p class="littlewish-part3-item-content">
                    {{ travelData.sponsor.context }}
                  </p>
                  <p class="sponsor_name_img" v-if="travelData.sponsor.adImg">
                    <img :src="travelData.sponsor.adImg" alt="" />
                    <span>赞助商</span>
                  </p>
                  <p class="sponsor_name_video" v-if="
                      travelData &&
                        travelData.sponsor &&
                        travelData.sponsor.advideo
                    ">
                    <video id="myVideo" :src="travelData.sponsor.advideo" controls></video>
                    <span>视频宣传</span>
                  </p>
                  <p class="littlewish-part3-item-content">
                    “{{ travelData.travelMappingList[0].name }}”品牌赞助了<span class="littlewish-part3-item-content-money">{{ travelData.travelMappingList[0].giftMoney }}</span>元
                  </p>
                </div>
              </div>
              <div class="littlewish-part4-wrapper">
                <p class="littlewish-part4-label">送礼列表</p>
                <div class="littlewish-part4-content">
                  <!--赞助商-->
                  <div class="littlewish-part4-content-item">
                    <img :src="travelData.travelMappingList[0].headImg" class="littlewish-part4-content-item-img" />
                    <div class="littlewish-part4-content-info">
                      <p class="littlewish-part4-content-info-content">
                        <span class="littlewish-part4-content-info-name">【{{ travelData.travelMappingList[0].name }}】</span>
                        <span class="littlewish-part4-content-info-txt">品牌赞助方-豪气赞助了
                          <span style="color: #EB5248">{{
                              travelData.travelMappingList[0].giftMoney
                            }}元</span></span>
                      </p>
                      <p class="littlewish-part4-content-time">
                        帮你实现愿望~^_^
                      </p>
                    </div>
                  </div>
                  <div v-for="(item, index) of travelData.travelTransDos" :key="index">
                    <!--用户-->
                    <div class="littlewish-part4-content-item">
                      <img :src="item.userInfo.headImg" class="littlewish-part4-content-item-img" />
                      <div class="littlewish-part4-content-info">
                        <!--礼物-->
                        <p class="littlewish-part4-content-info-content">
                          <span class="littlewish-part4-content-info-name">{{
                            item.userInfo.name
                          }}</span>
                          <span class="littlewish-part4-content-info-txt giftimg">赞助了
                            <span style="color: #EB5248">[{{ item.userGift.giftName }}]
                              <img :src="item.userGift.giftImg" /> x1</span>，支持了
                            <span style="color: #EB5248">{{ item.userGift.giftMoney }}元</span></span>
                        </p>
                        <!--豪气全包-->
                        <!-- <p class="littlewish-part4-content-info-content" v-if="item.giftCode == 9"><span class="littlewish-part4-content-info-name">{{item.name}}</span>
                      <span class="littlewish-part4-content-info-txt giftimg" style="color: #EB5248">豪气<img :src="item.gift.giftImg"> 全包赞助了，剩余全包赞助了{{item.giftMoney}}元</span>
                    </p> -->
                        <p class="littlewish-part4-content-time">
                          帮你实现愿望~^_^
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="littlewish-part5-wrapper">
                <div class="littlewish-part5-item">
                  <p class="littlewish-part5-item-btn globalCololr" @click="liwuShow = true">
                    赞助Ta
                  </p>
                </div>
                <div class="littlewish-part5-item">
                  <p class="littlewish-part5-item-btn globalCololr" @click="liwuShow = true">
                    带Ta同游
                  </p>
                </div>
              </div>
            </div>
            <!--礼物小程序-->
            <el-dialog width="80%" title="打开微信，扫一扫，或下载APP，立即认识Ta~" :visible.sync="liwuShow" append-to-body>
              <div class="liwu_bg">
                <!-- <img style="border-radius:20%;width:425px " src="../../../static/images/index/liwu.png" alt=""> -->
                <img src="../../../static/images/index/we.jpg" alt="" />
                <h3 style="text-align: center;margin: 20px 0;color: #f60">
                  （打开微信，扫一扫小程序码，或下载APP，立即认识Ta~）
                </h3>
              </div>
            </el-dialog>
          </el-dialog>
        </template>
      </div>
    </div>
    <!--    查看图片-->
    <el-dialog title="查看图片" :visible.sync="dialogVisible" width="40%">
      <div class="img_BG">
        <img :src="img_src" alt="" />
      </div>
    </el-dialog>
  </div>
</template>

<!--JS-->
<script>

import http from 'api/api'
export default {
  data () {
    return {
      tabIndex: 0,
      serviceShow: false,
      travelShow: false,
      img_list: [],
      serviceTab: 0,
      startTimeData: [],
      startTime: "",
      endTime: "",
      nameNumber: 1,
      nameService: "",
      nameTravel: "",
      nameCode: "",
      getUserData: "",
      UserPhoto: [],
      TravelList: "",
      Serves: "",
      servesData: "",
      travelData: "",
      dialogVisible: false,
      img_src: "",
      InfoData: "",
      liwuShow: false
    };
  },
  methods: {
    liwu () { },
    imgSet (src) {
      this.dialogVisible = true;
      this.img_src = src;
    },
    startTimeBtn (e) {
      this.startTimeData[0] = e;
    },
    endTimeBtn (e) {
      this.startTimeData[1] = e;
    },
    TimeDataBtn (e) {
      this.startTime = e[0];
      this.endTime = e[1];
    },
    serviceBtn (index) {
      let vm = this;
      if (!localStorage.getItem("pbw_user_pc_uid")) {
        vm.$router.push("/login");
        return;
      }
      if (index == 1) {
        if (vm.startTimeData.length == 0) {
          vm.$message.warning("请选择开始时间");
          return;
        }
      } else {
        if (vm.startTime == "") {
          vm.$message.warning("请选择结束时间");
          return;
        }
        if (vm.endTime == "") {
          vm.$message.warning("请选择结束时间");
          return;
        }
      }
      vm.$router.push(
        "/orderAdd?nameCode=" +
        vm.nameCode +
        "&service=" +
        vm.nameService +
        "&startTime=" +
        vm.startTime +
        "&endTime=" +
        vm.endTime +
        "&nameNumber=" +
        vm.nameNumber
      );
    },
    // 心愿详情
    TravelBtn (code) {
      let vm = this;
      vm.travelShow = true;
      // 获取详情
      selectTravelDetail({
        code: code
      }).then(res => {
        if (res.code == "000000") {
          vm.travelData = res.data;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 打开服务详情
    servesBtn (code) {
      let vm = this;
      vm.serviceShow = true;
      // 获取服务详情
      selectUserServesByCode({
        code: code,
        role: 2
      }).then(res => {
        if (res.code == "000000") {
          vm.servesData = res.data;
          if (res.data.serveCoverImg.indexOf(",") > -1) {
            vm.img_list = res.data.serveCoverImg.split(",");
          } else {
            vm.img_list.push(res.data.serveCoverImg);
            vm.img_list.push(res.data.serveCoverImg);
            vm.img_list.push(res.data.serveCoverImg);
          }
        } else {
          this.$message.warning(res.msg);
        }
      });
      // 获取评价
      queryEvelInfo({
        map: {
          serverCode: code + ""
        },
        nowPage: 1,
        nowPageDataNum: 99
      }).then(res => {
        if (res.code == "000000") {
          vm.InfoData = res.data;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    handleChange () { },
    tabBtn (index) {
      this.tabIndex = index;
    }
  },
  mounted () {
    this.nameCode = this.$route.query.nameCode;
    // 查看某服务
    if (this.$route.query.nameService) {
      this.nameService = this.$route.query.nameService;
      this.serviceShow = true;
      // 获取评价
      http.GET('/jw-function', {
        module: 'rating',
        operation: 'getDetailRating',
        product_id: this.nameService
      }).then((res) => {
        this.InfoData = res
      })
      // 获取服务详情
      http.GET('/jw-function', {
        module: 'product',
        operation: 'getDetail',
        id: this.nameService
      }).then((res) => {
        this.servesData = res.data
      })
    }
    // 查看某心愿
    // if (this.$route.query.nameTravel) {
    //   this.nameTravel = this.$route.query.nameTravel;
    //   this.travelShow = true;
    //   // 获取心愿详情
    //   selectTravelDetail({
    //     code: this.$route.query.nameTravel
    //   }).then(res => {
    //     if (res.code == "000000") {
    //       this.travelData = res.data;
    //     } else {
    //       this.$message.warning(res.msg);
    //     }
    //   });
    // }

    // 获取个人信息
    http.GET('/jw-function', {
      module: 'home',
      operation: 'getUserHome',
      uid: this.$route.query.nameCode
    }).then((res) => {
      this.getUserData = res
    })


    // // 获取照片墙
    // getUserPhotoWall({
    //   uid: vm.$route.query.nameCode
    // }).then(res => {
    //   if (res.code == "000000") {
    //     if (res.data.imgPath != null) {
    //       if (res.data.imgPath.indexOf(",") > -1) {
    //         vm.UserPhoto = res.data.imgPath.split(",");
    //       } else {
    //         vm.UserPhoto.push(res.data.imgPath);
    //       }
    //     }
    //   } else {
    //     this.$message.warning(res.msg);
    //   }
    // });
    // // 获取用户心愿
    // selectTravelList({
    //   map: {
    //     uid: vm.$route.query.nameCode
    //   },
    //   type: 0,
    //   nowPage: 1,
    //   nowPageDataNum: 10
    // }).then(res => {
    //   if (res.code == "000000") {
    //     vm.TravelList = res.data;
    //   } else {
    //     this.$message.warning(res.msg);
    //   }
    // });
    // // 获取用户发布的服务
    // selectUserServes({
    //   userCode: vm.$route.query.nameCode,
    //   role: 2
    // }).then(res => {
    //   if (res.code == "000000") {
    //     vm.Serves = res.data;
    //   }
    // });
    // 图片旋转
    require("../../../static/js/jquery.roundabout-1.0.min.js");
    require("../../../static/js/jquery.easing.1.3.js");
    $(function () {
      $("#featured-area ul").roundabout({
        easing: "easeOutInCirc",
        duration: 600
      });
    });
  },
  filters: {
    GetTime (value) {
      var time = new Date(value * 1000);
      function add0 (m) {
        return m < 10 ? "0" + m : m;
      }
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();
      var timeResult =
        add0(m) + "月" + add0(d) + "日 " + add0(h) + ":" + add0(mm);
      if (timeResult == "1970-01-01" || timeResult == "1970-01-02") {
        return "--";
      } else {
        return timeResult;
      }
    }
  }
};
</script>

<!--css样式-->
<style lang="scss" scoped>
@import '../../../src/scss/commonH5.scss';
/* ==== 旅游景点页面 {{{ ==== */
/*当季景点推荐*/
.liwu_bg {
  width: 100%;
  text-align: center;
  img {
    width: 400px;
    height: 400px;
  }
}
.prize {
  border-top: 5px solid #f5f5f5;
  padding: 10px 0;
}
.img_BG img {
  width: 100%;
  height: 100%;
}
.giftimg img {
  width: 30px;
  height: 30px;
}
.sponsor_name_img {
  border-radius: 5px;
  padding: 5px 10px;
  position: relative;
}
.sponsor_name_img span {
  position: absolute;
  top: 10px;
  right: 21px;
  font-size: 15px;
  border: 1px solid #f5f5f5;
  padding: 0px 5px;
  color: #fff;
}
.sponsor_name_video {
  padding: 5px 10px;
  border-radius: 5px;
  position: relative;
  background: #fff;
}
.sponsor_name_video span {
  position: absolute;
  top: 10px;
  right: 21px;
  font-size: 15px;
  border: 1px solid #f5f5f5;
  padding: 0px 5px;
  color: #fff;
}
.sponsor_name_video video {
  border-radius: 5px;
  width: 100%;
  height: 230px;
}
.sponsor_name_img img {
  width: 100%;
  height: 230px;
  box-sizing: border-box;
  border-radius: 5px;
}
.jd_floor2,
.jd_floor4,
.jd_floor6 {
}
.jd_floor {
  padding: 0 0 150px 0;
}
.jd_floor .mc2 {
  background: none !important;
}
.jd_floor .lay-zone-cont2 {
  margin-top: 30px;
}
.jd-list-main .sel-month {
  text-align: center;
  width: 100%;
}
.jd-list-main .sel-month a {
  color: #999;
  cursor: pointer;
  font-size: 16px;
  margin: 0 15px;
}
.jd-list-main .sel-month a:hover {
  border-bottom: 2px solid $fontColor;
  color: $fontColor;
}
.jd-list-main .sel-month a.on {
  border-bottom: 2px solid $fontColor;
  color: $fontColor;
  font-weight: 700;
}
.jd-list-main ul {
  display: inline-block;
  margin-right: -20px;
}
.jd-list-main ul li {
  float: left;
  margin-right: 20px;
  margin-top: 20px;
  overflow: hidden;
  height: 235px;
  width: 235px;
  position: relative;
}
.jd-list-main ul li img {
  display: block;
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}
.jd-list-main ul li a:hover img {
  opacity: 0.8;
  filter: alpha(opacity=80);
  transform: translateY(1.03);
  -webkit-transform: scale(1.03);
  -moz-transform: scale(1.03);
}
.jd-list-main ul li .inner-info {
  text-align: center;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.jd-list-main ul li .inner-info .info {
  color: #fff;
  line-height: 23px;
  margin-top: 100px;
}
.jd-list-main ul li .inner-info .info h2 {
  font-size: 20px;
}
.jd-list-main ul li .inner-info .info span {
  font-size: 20px;
  letter-spacing: 2px;
}
.jd-list-main ul li .title {
  background: url(../../../static/images/icon-tit-bg.png) repeat;
  width: 100%;
  position: absolute;
  bottom: 0;
}
.jd-list-main ul li .title span {
  display: table-cell;
  vertical-align: middle;
  color: #fff;
  font-size: 14px;
  padding: 0 5px;
  text-align: center;
  height: 42px;
  line-height: 20px;
  width: 225px;
}
/*热门景点推荐*/
.jd-hotList-main ul {
  display: inline-block;
  margin-right: -20px;
}
.jd-hotList-main ul li {
  border-radius: 5px;
  cursor: pointer;
  background: #474664;
  float: left;
  overflow: hidden;
  margin-right: 20px;
  margin-top: 20px;
  height: 320px;
  width: 320px;
  position: relative;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
}
.jd-hotList-main ul li:hover {
  opacity: 0.8;
  filter: alpha(opacity=80);
  transform: scale(1.03);
  -webkit-transform: scale(1.03);
  -moz-transform: scale(1.03);
  box-shadow: 2px 3px 5px #666;
}
.jd-hotList-main ul li .tag {
  background: url(../../../static/images/icon-label.png) no-repeat;
  color: #fff;
  font-size: 18px;
  padding-left: 8px;
  height: 32px;
  z-index: 10;
  position: absolute;
  top: 20px;
  right: 0;
}
.jd-hotList-main ul li .tag i {
  display: inline-block;
  padding: 0 10px;
  height: 32px;
  line-height: 32px;
  background: #ff586b;
}
.jd-hotList-main ul li a.img {
  display: block;
  overflow: hidden;
  height: 250px;
  width: 320px;
}
.jd-hotList-main ul li a.img img {
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
}
.jd-hotList-main ul li a.img:hover img {
  opacity: 0.8;
  filter: alpha(opacity=80);
  transform: scale(1.03);
  -webkit-transform: scale(1.03);
  -moz-transform: scale(1.03);
}
.jd-hotList-main ul li .spot_desc {
  padding: 5px 15px;
  background: #474664 !important;
}
.jd-hotList-main ul li .spot_desc .addr {
  margin-top: 3px;
}
.jd-hotList-main ul li .spot_desc .addr label {
  color: #ffffff;
  font-size: 15px;
  width: 87%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.jd-hotList-main ul li .spot_desc .addr a {
  color: $fontColor;
  font-size: 12px;
  margin-top: 1px;
}
.jd-hotList-main ul li .spot_desc .addr a:hover {
  text-decoration: underline;
}
.jd-hotList-main ul li .spot_desc .nums {
  margin-top: 10px;
  margin-right: -1px;
  overflow: hidden;
}
.jd-hotList-main ul li .spot_desc .nums em {
  border-right: 1px solid #e8e8e8;
  color: #c4c3e6;
  display: inline;
  float: left;
  font-size: 13px;
  width: 49%;
}
.jd-hotList-main ul li .spot_desc .nums .e1 {
  text-align: left;
}
.jd-hotList-main ul li .spot_desc .nums .e2 {
  text-align: center;
}
.jd-hotList-main ul li .spot_desc .nums .e3 {
  border-right: 0;
  text-align: right;
}
.reserve {
  width: 100%;
  padding: 30px 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tab_bg {
  margin: 10px 0;
  text-align: center;
  border: 1px solid #ddd;
  padding: 10px 0;
  span {
    color: #fff;
    padding: 10px 20px;
    margin: 0 30px;
  }
  .tab_Sel {
    color: $fontColor;
    border-bottom: 2px solid $fontColor;
  }
}
.service_bg {
  color: #fff;
  width: 100%;
  padding: 10px;
  font-size: 15px;
  table {
    width: 100%;
  }
  tr {
    border-bottom: 1px dotted #ddd;
    td:first-child {
      width: 100px;
    }
  }
  td {
    padding: 10px;
  }
}
#homePage {
  color: #fff;
  .homePage_content {
    width: 1200px;
    margin: 0 auto;
  }
  .banner_img {
    width: 100%;
    height: 550px;
  }
  .banner_img img {
    width: 100%;
    height: 550px;
  }
  /* ==== 陪行页面 {{{ ==== */
  /* 导游概述 */
  .sec_guide_desc {
    margin-top: -160px;
    height: 320px;
    position: relative;
  }
  .sec_guide_desc .guide-imge {
    border-radius: 50%;
    height: 320px;
    width: 320px;
    z-index: 10;
    position: absolute;
    left: 0;
  }
  .sec_guide_desc .guide-imge img {
    border-radius: 50%;
    height: 320px;
    width: 320px;
    transition: all 0.3s;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    box-shadow: 5px 4px 10px 2px #384350;
  }
  .sec_guide_desc .guide-imge a:hover img {
    transform: translateX(18px);
    -webkit-transform: translateX(18px);
    -moz-transform: translateX(18px);
  }
  .sec_guide_desc .guide-cont {
    background: linear-gradient(
      90deg,
      rgba(31, 79, 240, 0.5),
      rgba(134, 97, 229, 0.5) 90%,
      rgba(141, 101, 234, 0)
    );
    height: 200px;
    width: 1025px;
    position: absolute;
    right: 0;
    top: 60px;
    border-radius: 0 10px 10px 0;
    box-shadow: 4px 4px 9px #6f7073;
  }
  /*---*/
  .guide-cont .lt-ct {
    color: #fff;
    margin-left: 100px;
  }
  .guide-cont .lt-ct .name,
  .guide-cont .lt-ct .addr,
  .guide-cont .lt-ct .lang {
    margin-top: 20px;
  }
  .guide-cont .lt-ct .name em {
    font-size: 14px;
    margin-right: 20px;
    line-height: 24px;
  }
  .guide-cont .lt-ct .name em i {
    margin-left: 10px;
  }
  .guide-cont .lt-ct .name em.n1 {
    font-size: 24px;
  }
  .guide-cont .lt-ct .addr {
    font-size: 14px;
    height: 30px;
    line-height: 30px;
    /*width: 260px;*/
  }
  .guide-cont .lt-ct .addr em.a1 {
    /*margin-left: 15px;*/
    margin-right: 30px;
  }
  .guide-cont .lt-ct .addr em.a2 {
    margin-right: 15px;
  }
  .guide-cont .lt-ct .lang {
    font-size: 14px;
  }
  .guide-cont .lt-ct .lang a {
    background: #2c363f;
    border: 1px solid #5f6972;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
    margin-right: 10px;
    padding: 2px 10px 4px;
  }
  /*---*/
  .guide-cont .rt-ct {
    color: #fff;
  }
  .guide-cont .rt-ct .serv,
  .guide-cont .rt-ct .cmts,
  .guide-cont .rt-ct .care {
    margin-top: 20px;
    margin-right: 50px;
    line-height: 24px;
  }
  .guide-cont .rt-ct .serv {
    font-size: 14px;
  }
  .guide-cont .rt-ct .serv b {
    font-size: 24px;
  }
  .guide-cont .rt-ct .cmts em {
    font-size: 14px;
    margin-right: 10px;
  }
  .guide-cont .rt-ct .cmts em b {
    font-size: 24px;
  }
  .guide-cont .rt-ct .care {
    font-size: 14px;
    margin-right: 0;
    height: 30px;
    width: 100%;
  }
  .guide-cont .rt-ct .care span b {
    font-size: 24px;
  }
  .guide-cont .rt-ct .care .c2 {
    margin-right: 60px;
  }
  /*.guide-cont .rt-ct .care .c1 a {*/
  /*background: url(../../../static/images/icon-like.png) no-repeat right center;*/
  /*padding-right: 28px;*/
  /*}*/
  /*.guide-cont .rt-ct .care .c2 a {*/
  /*background: url(../../../static/images/icon-unlike.png) no-repeat right center;*/
  /*padding-right: 28px;*/
  /*}*/
  /*---*/
  .guide-cont .ft-ct {
    margin-left: 100px;
    margin-top: 210px;
  }
  .guide-cont .ft-ct label {
    background: url(../../../static/images/icon-auth-succ.png) no-repeat left
      top;
    display: inline-block;
    color: #fff;
    font-size: 12px;
    margin-right: 30px;
    padding-left: 30px;
  }
  .guide-cont .ft-ct label em {
    color: #999;
  }
  /* 导游详细展示 */
  .sec_guide_container {
    margin-top: 30px;
  }
  .sec_guide_container .hd {
    background: url(../../../static/images/icon-arrow.png) no-repeat left center;
    border-top: 3px solid #cecece;
    color: #fff;
    font-size: 24px;
    padding: 10px 0 10px 20px;
    line-height: 30px;
    position: relative;
  }
  .sec_guide_container .hd .favor {
    font-size: 18px;
    position: absolute;
    right: 15px;
  }
  .sec_guide_container .hd .favor img {
    margin-right: 10px;
    vertical-align: top;
    height: 30px;
    width: 30px;
  }
  /*(左侧)主体*/
  .sec_guide_container .lay-gd-main {
    width: 880px;
    position: relative;
  }
  .sec_guide_container .lay-gd-main2 {
    width: 760px;
    position: relative;
  }
  .lay-gd-main .nav li {
    display: inline;
    float: left;
    margin-right: 16px;
    cursor: pointer;
  }
  .lay-gd-main .nav li a {
    background: #fff;
    border: 1px solid #364451;
    border-radius: 4px;
    color: #364451;
    display: block;
    font: 18px/32px 'sans-serif';
    text-align: center;
    height: 34px;
    width: 112px;
  }
  .lay-gd-main .nav li.on a {
    background: $fontLinear;
    color: #fff;
  }
  .lay-gd-main .i-summary .ct {
    color: #fff;
    font-size: 14px;
    margin: 0 23px;
    line-height: 30px;
  }
  .lay-gd-main .i-summary .ct .scene {
    color: #fff;
    font-size: 12px;
    padding: 8px 0;
  }
  .lay-gd-main .i-summary .ct .scene label {
    background: url(../../../static/images/icon-scene.png) no-repeat;
    display: inline-block;
    padding-left: 24px;
    height: 18px;
    line-height: 18px;
    width: 28px;
  }
  /*用户点评*/
  .lay-gd-main .i-summary .ct p {
    padding-top: 20px;
    text-indent: 24px;
    font-size: 18px;
  }
  .lay-gd-main .i-photo .photo-ct {
    background: #e6e6e6;
    margin: 10px auto 0;
    height: 350px;
    width: 850px;
    box-shadow: 0 0 6px rgba(50, 50, 50, 0.4);
    -webkit-box-shadow: 0 0 6px rgba(50, 50, 50, 0.4);
    -moz-box-shadow: 0 0 6px rgba(50, 50, 50, 0.4);
  }
  .lay-gd-main .i-photo2 .photo-ct {
    background: url(../../../static/images/photo-bg.jpg) no-repeat center
      #e6e6e6;
    height: 530px;
  }
  /* featured-area */
  #featured-area {
    height: 310px;
    width: 850px;
    margin: 0 auto;
    padding-top: 20px;
  }
  .roundabout-holder {
    list-style: none;
    width: 500px;
    height: 300px;
    margin: 0px auto;
  }
  .roundabout-moveable-item {
    font-size: 12px !important;
    height: 225px;
    width: 450px;
    cursor: pointer;
    padding: 5px;
    border: 1px solid #aaaaaa;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    background: #f9f9f9;
  }
  .roundabout-moveable-item img {
    height: 100%;
    width: 100%;
    background-color: #ffffff;
    margin: 0;
  }
  .roundabout-in-focus {
    cursor: auto;
  }
  .roundabout-in-focus:hover {
    -webkit-box-shadow: 0px 0px 20px #787878;
    -moz-box-shadow: 0px 0px 20px #787878;
    background: #f9f9f9;
  }
  .roundabout a:active,
  .roundabout a:focus,
  .roundabout a:visited {
    outline: none;
    text-decoration: none;
  }
  .roundabout li {
    margin: 0;
  }
  /*我的旅图*/
  .i-trip-photo .tripPhoto-ct {
    margin-top: 10px;
    overflow: hidden;
  }
  .i-trip-photo .tripPhoto-ct ul {
    display: inline-block;
    margin-left: 10px;
    margin-right: -13px;
    width: 870px;
  }
  .i-trip-photo .tripPhoto-ct ul li {
    border: 1px solid #fff;
    border-radius: 2px;
    float: left;
    margin-bottom: 20px;
    overflow: hidden;
    margin-right: 13px;
    width: 275px;
    box-shadow: 0 0 5px rgba(50, 50, 50, 0.3);
    -webkit-box-shadow: 0 0 5px rgba(50, 50, 50, 0.3);
    -moz-box-shadow: 0 0 5px rgba(50, 50, 50, 0.3);
    transition: all 0.3s;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
  }
  .i-trip-photo .tripPhoto-ct ul li a.img {
    display: block;
    overflow: hidden;
  }
  .i-trip-photo .tripPhoto-ct ul li a.img img {
    display: block;
    width: 275px;
  }
  .tripPhoto-ct .view-more {
    margin: -5px auto 0;
    width: 860px;
  }
  .lay-gd-main .i-play-serv .playServ-dy {
    margin-top: 10px;
  }
  .playServ-dy ul {
    display: inline-block;
  }
  .playServ-dy ul li {
    background: #474664;
    display: inline;
    float: left;
    overflow: hidden;
    margin: 0 11px 31px;
    height: 350px;
    width: 270px;
    position: relative;
  }
  /*玩游-陪游服务*/
  .lay-gd-main .i-play-serv .playServ-ct {
    margin-top: 10px;
  }
  .playServ-ct ul {
    display: inline-block;
  }
  .playServ-ct ul li {
    border-radius: 5px;
    background: #474664;
    display: inline;
    float: left;
    overflow: hidden;
    margin: 0 11px 31px;
    width: 265px;
    position: relative;
    transition: all 0.3s;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  .playServ-ct ul li:hover {
    opacity: 0.8;
    filter: alpha(opacity=80);
    transform: scale(1.03);
    -webkit-transform: scale(1.03);
    -moz-transform: scale(1.03);
  }
  .playServ-ct ul li .tag {
    background: url(../../../static/images/icon-label.png) no-repeat;
    color: #fff;
    font-size: 18px;
    padding-left: 8px;
    height: 32px;
    z-index: 10;
    position: absolute;
    top: 20px;
    right: 0;
  }
  .playServ-ct ul li .tag i {
    background: $fontColor;
    display: inline-block;
    padding: 0 10px;
    height: 32px;
    line-height: 32px;
  }
  .playServ-ct ul li a.img {
    display: block;
    overflow: hidden;
    height: 220px;
    width: 270px;
  }
  .playServ-ct ul li a.img img {
    transition: all 0.3s;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
  }
  .playServ-ct ul li a.img:hover img {
    opacity: 0.8;
    filter: alpha(opacity=80);
    transform: scale(1.03);
    -webkit-transform: scale(1.03);
    -moz-transform: scale(1.03);
  }
  .playServ-ct ul li .serv {
    background: #474664;
    margin: 0 auto;
    padding: 25px 10px 10px 10px;
    position: relative;
  }
  .playServ-ct ul li .serv .uimg {
    border: 3px solid #fff;
    border-radius: 50%;
    display: block;
    overflow: hidden;
    height: 36px;
    width: 36px;
    position: absolute;
    left: 10px;
    top: -18px;
  }
  .playServ-ct ul li .serv h2 {
    color: #fff;
    padding: 6px 8px;
    margin-bottom: 12px;
    background: #3a3956;
    border-radius: 4px;
    width: 100%;
    box-sizing: border-box;
    font-size: 16px;
  }
  .playServ-ct ul li .serv h4 {
    font-size: 13px;
    border: 1px solid $fontColor;
    padding: 2px 10px;
    border-radius: 20px;
    color: $fontColor;
    display: inline-block;
  }
  .playServ-ct ul li .serv label {
    position: absolute;
    bottom: 12px;
    right: 15px;
    color: $fontColor;
    font-weight: bold;
    font-size: 14px;
  }
  .playServ-ct ul li .serv label .collect,
  .playServ-ct ul li .serv label .share {
    display: inline-block;
    margin-left: 5px;
    height: 14px;
    width: 14px;
  }
  .playServ-ct ul li .serv label .collect {
    background: url(../../../static/images/icon-sm-star.png) no-repeat center;
  }
  .playServ-ct ul li .serv label .share {
    background: url(../../../static/images/icon-sm-share.png) no-repeat center;
  }
  .playServ-ct .add_gl_new {
    margin-top: 30px;
    text-align: center;
  }
  .playServ-ct .add_gl_new a {
    background: #ffd42f;
    color: #fff;
    border-radius: 3px;
    display: inline-block;
    *display: inline;
    *zoom: 1;
    font: 18px/40px 'sans-serif';
    margin-left: -45px;
    text-align: center;
    height: 40px;
    width: 270px;
  }
  .playServ-ct .add_wx_new {
    margin-top: 30px;
    text-align: center;
  }
  .playServ-ct .add_wx_new a {
    background: $fontLinear;
    color: #fff;
    border-radius: 3px;
    display: inline-block;
    *display: inline;
    *zoom: 1;
    font: 18px/40px 'sans-serif';
    margin-left: -65px;
    text-align: center;
    height: 40px;
    width: 270px;
  }
  .playServ-ct .view-more {
    margin: 5px auto;
    width: 855px;
  }
  /*预订须知*/
  .i-terms .terms-ct {
    margin-left: 23px;
    margin-top: 25px;
  }
  .i-terms .terms-ct .lss {
    position: relative;
  }
  .i-terms .terms-ct .lss .line {
    border-left: 1px solid #ccc;
    height: 100%;
    z-index: 9;
    position: absolute;
    left: 40px;
    top: 0;
  }
  .i-terms .terms-ct .lss .line i {
    background: $fontLinear;
    color: #fff;
    font: 14px/18px 'sans-serif';
    padding: 2px 5px;
    white-space: nowrap;
    height: 18px;
    position: absolute;
    left: -20px;
    top: 50%;
  }
  .i-terms .terms-ct .tit {
    background: #fff;
    color: #333;
    font: 16px/42px 'sans-serif';
    padding-left: 10px;
    height: 42px;
    position: relative;
    z-index: 10;
    box-shadow: 0 0 5px rgba(200, 200, 200, 0.3);
    -webkit-box-shadow: 0 0 5px rgba(200, 200, 200, 0.3);
    -moz-box-shadow: 0 0 5px rgba(200, 200, 200, 0.3);
  }
  .i-terms .terms-ct .tit label {
    color: #666;
    margin-left: 50px;
  }
  .i-terms .terms-ct .ct {
    padding-left: 100px;
    overflow: hidden;
  }
  .i-terms .terms-ct .ct p {
    color: #333;
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 6px;
  }
  .i-terms .terms-ct .ct .lists {
    margin-top: -1px;
  }
  .i-terms .terms-ct .ct .lists li {
    border-top: 1px solid #ddd;
    display: inline;
    float: left;
    padding: 30px 0;
    width: 100%;
  }
  .i-terms .terms-ct .ct .lists li .scene {
    color: #333;
    font-size: 12px;
    padding: 8px 0;
  }
  .i-terms .terms-ct .ct .lists li .scene label {
    background: url(../../../static/images/icon-scene.png) no-repeat;
    display: inline-block;
    padding-left: 24px;
    height: 18px;
    width: 28px;
  }
  /*用户点评*/
  .i-ls-cmts .cmts-ct {
    margin-left: 23px;
    margin-top: 25px;
  }
  .i-ls-cmts .cmts-ct .whole_score {
    background: #fff;
    padding: 20px 0;
    overflow: hidden;
    _zoom: 1;
  }
  .whole_score .rate {
    color: #333;
    font-size: 20px;
    margin: 7px 0 0 20px;
    text-align: center;
    width: 200px;
  }
  .whole_score .rate span {
    font-size: 18px;
  }
  .whole_score .rate b {
    font-size: 30px;
    line-height: 30px;
  }
  .whole_score .actor_new {
    margin-top: 10px;
    padding: 0 20px 0 50px;
    white-space: nowrap;
    line-height: 15px;
    width: 550px;
  }
  .whole_score .actor_new dt {
    float: left;
    color: #333;
    font-size: 15px;
    line-height: 30px;
  }
  .whole_score .actor_new dd {
    overflow: hidden;
  }
  .whole_score .actor_new dd span {
    background: #fff;
    border: 1px solid $fontColor;
    border-radius: 20px;
    color: $fontColor;
    float: left;
    font: 15px/28px 'sans-serif';
    margin-right: 7px;
    margin-bottom: 10px;
    padding: 0 12px;
    height: 28px;
    box-shadow: 1px 1px 3px rgba(50, 50, 50, 0.3);
    -webkit-box-shadow: 1px 1px 3px rgba(50, 50, 50, 0.3);
    -moz-box-shadow: 1px 1px 3px rgba(50, 50, 50, 0.3);
  }
  .u-ls-comments {
    border: 1px solid #ddd;
    padding-bottom: 30px;
    box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
    -webkit-box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
    -moz-box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
  }
  /*排序条*/
  .ls-zone-order {
    position: relative;
  }
  .ls-zone-order .order-bar {
    background: #eee;
    border-bottom: 1px solid #ddd;
    padding-left: 55px;
    height: 50px;
    line-height: 48px;
  }
  .ls-zone-order .order-bar span a {
    display: inline-block;
    height: 50px;
    padding: 0 10px 0 15px;
    vertical-align: top;
    overflow: hidden;
    cursor: pointer;
  }
  .ls-zone-order .order-bar span a:hover {
    text-decoration: underline;
  }
  .ls-zone-order .order-bar span a.on {
    color: $fontColor;
  }
  /*右侧统计*/
  .ls-zone-order .order-type {
    position: absolute;
    right: 30px;
    top: 1px;
    height: 50px;
    line-height: 50px;
    *line-height: 42px;
  }
  .ls-zone-order .order-type .searchable-select-holder {
    line-height: 30px;
  }
  /*打赏记录*/
  .i-ls-cmts .cmts-ct .reward_record {
    border: 1px solid #ddd;
    margin-top: 50px;
    box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
    -webkit-box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
    -moz-box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
  }
  .reward_record .reward {
    background: #eee;
    padding: 20px 0;
    text-align: center;
    line-height: 40px;
  }
  .reward_record .reward a {
    color: #333;
    display: inline-block;
    font-size: 28px;
    margin: 0 40px;
    padding-left: 50px;
    height: 40px;
  }
  .reward_record .reward a:hover {
    color: $fontColor;
  }
  .reward_record .reward .a1 {
    background: url(../../../static/images/shang.png) no-repeat left center;
  }
  .reward_record .reward .a2 {
    background: url(../../../static/images/zan.png) no-repeat left center;
  }
  .ls_record .record {
    color: #333;
    font-size: 20px;
    padding: 40px 0;
    text-align: center;
    line-height: 40px;
    width: 100%;
  }
  .ls_record .record .s1 {
    background: url(../../../static/images/icon-big-arrow.png) no-repeat;
    display: inline-block;
    margin-right: 110px;
    text-align: center;
    height: 40px;
    width: 290px;
  }
  .ls_record .record .s2 {
    margin-left: 110px;
  }

  /*---*/
  .list_form_tab {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
  }
  .list_form_tab th {
    color: #3d5480;
    font-size: 14px;
    height: 50px;
    text-align: center;
  }
  .list_form_tab td {
    color: #333;
    line-height: 22px;
    padding: 10px 5px;
  }
  .list_form_tab th,
  .list_form_tab td {
    border-top: 1px solid #e8e8e8;
    word-break: break-all;
    word-wrap: break-word;
  }
  /*发表评价*/
  .i-ls-cmts .cmts-ct .publish_cmts {
    border: 1px solid #ddd;
    margin-top: 50px;
    box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
    -webkit-box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
    -moz-box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
  }
  .i-ls-cmts .cmts-ct .publish_cmts .cmts-main {
    margin: 10px;
  }
  .i-ls-cmts .cmts-ct .publish_cmts .cmts-main h2 {
    color: $fontColor;
    font-size: 20px;
  }
  .i-ls-cmts .cmts-ct .publish_cmts .cmts-main textarea {
    background: #fff;
    border-color: #aaa #ddd #ddd #aaa;
    border-style: solid;
    border-width: 1px;
    color: #555;
    float: left;
    font-size: 14px;
    outline: none;
    resize: none;
    margin: 15px 0;
    overflow-y: auto;
    padding: 1%;
    height: 150px;
    width: 98%;
  }
  .i-ls-cmts .cmts-ct .publish_cmts .cmts-main .btn-publish {
    background: $fontLinear;
    border-radius: 2px;
    color: #fff;
    display: inline-block;
    font: 15px/34px 'sans-serif';
    text-align: center;
    height: 34px;
    width: 110px;
    box-shadow: 1px 1px 3px rgba(50, 50, 50, 0.4);
    -webkit-box-shadow: 1px 1px 3px rgba(50, 50, 50, 0.4);
    -moz-box-shadow: 1px 1px 3px rgba(50, 50, 50, 0.4);
  }
  /*用户评价*/
  .user-comments-container {
    overflow: hidden;
    _zoom: 1;
    width: 100%;
  }
  .user-comments-list {
    display: block;
    margin: 12px;
    *zoom: 1;
  }
  .user-comments-list .user-name {
    float: left;
    width: 80px;
    font: 12px/1.5 NSimSun;
    color: #ffffff;
  }
  .user-comments-list .comments-content {
    float: left;
    width: 749px;
    background: #fcfcfc;
    border: 1px solid #eee;
  }
  .user-comments-list .comments-content .h {
    height: 36px;
    line-height: 36px;
    padding-left: 17px;
  }
  .user-comments-list .score {
    vertical-align: middle;
    margin-top: -2px;
  }
  .score {
    background: url(../../../static/images/score.png) repeat-x 0 -16px;
    height: 16px;
    width: 80px;
    position: relative;
  }
  .score i {
    background: url(../../../static/images/score.png) repeat-x;
    display: block;
    height: 16px;
    position: absolute;
    top: 0;
    left: 0;
  }
  .user-comments-list .comments-content .notch {
    top: 7px;
    left: -20px;
  }
  .user-comments-list .items {
    display: inline-block;
    float: left;
    margin-bottom: 20px;
    _zoom: 1;
  }
  .user-comments-list .comment-date {
    right: 25px;
    top: 0;
    font-weight: normal;
  }
  .user-comments-list .comments-content strong {
    position: relative;
    display: inline-block;
    *zoom: 1;
    *display: inline;
    top: 0;
    color: #333;
  }
  .user-comments-list .comments-content .star {
    display: inline-block;
    *zoom: 1;
    *display: inline;
    width: 22px;
    height: 21px;
    overflow: hidden;
    position: relative;
    top: 5px;
  }
  .user-comments-list .comments-content .notch b {
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    font-size: 0;
    line-height: 0;
    border: 10px dashed transparent;
    border-right: 10px solid #ddd;
  }
  .user-comments-list .comments-content .notch .cb {
    border-right-color: #fcfcfc;
    left: 1px;
  }
  .user-comments-list .type-show,
  .user-comments-list .type-comment {
    color: #4d4c4c;
    font: 12px/20px SimSun;
    margin: 0 17px;
    padding: 17px 0;
    border-top: 1px solid #eee;
  }
  .user-comments-list .type-show .cc {
    width: 700px;
  }
  .user-comments-list .type-show .show-pic-container li {
    margin: 15px 10px 0 0;
  }
  .user-comments-list .type-show .show-pic-desc {
    color: #666;
    margin: 0;
  }
  .user-comments-list .type-show .show-addr {
    color: #999;
  }
  /* }}} */
  /*(右侧)边栏*/
  .sec_guide_container .lay-gd-side {
    width: 360px;
  }
  .lay-gd-side .i-service {
    margin-top: 36px;
  }
  .lay-gd-side .i-service .service-ct {
    margin: 0 auto;
    width: 342px;
  }
  .i-service .service-ct ul {
    display: inline-block;
    margin-right: -15px;
  }
  .i-service .service-ct ul li {
    float: left;
    margin-right: 12px;
    width: 140px;
  }
  .i-service .service-ct ul li.last {
    width: 40px;
  }
  .i-service .service-ct ul li label {
    display: block;
    color: #999;
    font-size: 14px;
  }
  .i-service .service-ct ul li .ipt-text {
    background: url(../../../static/images/icon-datepicker-bg.png) no-repeat 95%
      center #fff;
    border: 1px solid #ddd;
    padding: 10px 5px;
    outline: none;
    height: 20px;
    line-height: 20px;
    width: 108px;
  }
  .i-service .service-ct ul li select {
    border: 1px solid #ddd;
    padding: 5px;
    height: 42px;
    width: 40px;
  }
  .i-service .service-ct .my-serv {
    margin-top: 15px;
  }
  .i-service .service-ct .my-serv h2 {
    color: #999;
    font-size: 12px;
  }
  .i-service .service-ct .my-serv .ct {
    border: 1px solid #ddd;
    color: #333;
    font-size: 12px;
    margin-top: 5px;
    height: 74px;
    width: 340px;
    position: relative;
    box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
    -webkit-box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
    -moz-box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
  }
  .i-service .service-ct .my-serv .ct span {
    display: block;
    margin: 15px 40px 0 15px;
    word-break: break-all;
  }
  .i-service .service-ct .my-serv .ct span .pickup {
    background: url(../../../static/images/icon-pickup.png) no-repeat left
      center;
    color: $fontColor;
    padding-left: 22px;
  }
  .i-service .service-ct .my-serv .ct .close {
    background: url(../../../static/images/icon-close.png) no-repeat;
    height: 18px;
    width: 18px;
    position: absolute;
    top: 28px;
    right: 5px;
  }
  .i-service .service-ct .btn-bookNow {
    margin-top: 15px;
    text-align: center;
    height: 48px;
    line-height: 48px;
    width: 100%;
  }
  .i-service .service-ct .btn-bookNow a {
    background: $fontLinear;
    border-radius: 2px;
    color: #fff;
    display: block;
    font-size: 18px;
  }
  .i-service .service-ct .btn-bookNow a:hover {
    background: $fontLinear;
  }
  .i-service .service-ct .process {
    border: 1px solid #ddd;
    float: left;
    margin-top: 20px;
    box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
    -webkit-box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
    -moz-box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
  }
  .i-service .service-ct .process span {
    background: #fff;
    display: inline;
    float: left;
    padding-bottom: 8px;
    text-align: center;
    width: 85px;
  }
  .i-service .service-ct .process span i {
    background: url(../../../static/images/icon-big-cicle.png) no-repeat center;
    color: #fff;
    display: block;
    font-size: 14px;
    font-weight: 700;
    margin: 0 auto;
    padding-top: 20px;
    height: 38px;
    width: 38px;
  }
  /**/
}
/*心愿*/
.littlewish-wrapper {
  color: #fff;
}
.littlewish-part1-wrapper {
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;
}
.littlewish-part1-img {
  width: 100%;
  height: 500px;
  border-radius: 10px;
}
.littlewish-part1-content {
  padding: 50px 0;
  text-align: center;
}
.littlewish-part1-content-txt {
  font-size: 25px;
  padding-bottom: 10px;
}
.littlewish-part1-content-time-wrapper {
  font-size: 15px;
  color: #bdc9d7;
}
.littlewish-part1-content-time-wrapper .iconfont {
  vertical-align: text-top;
}
.littlewish-part1-content-time {
  padding-left: 40px;
}
.littlewish-part1-footer {
  display: flex;
}
.littlewish-part1-footer-info {
  flex: 1;
}
.littlewish-part1-footer-status {
  flex: 1;
  text-align: right;
  color: red;
}
.littlewish-part1-footer-status .iconfont {
  font-size: 80px;
}
.littlewish-part1-footer-info-img {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}
.littlewish-part1-footer-info-name {
  color: #515151;
  font-size: 22px;
  padding-left: 20px;
}
.littlewish-part2-wrapper {
  padding: 0 20px;
}
.littlewish-part2-title-wrapper {
  padding: 20px 0;
  border-bottom: 1px solid #e7ebf1;
  display: flex;
}
.littlewish-part2-title {
  flex: 0 50%;
  font-size: 18px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.littlewish-part2-title-txt {
  padding-left: 10px;
}
.littlewish-part2-content-label {
  text-align: center;
  font-size: 21px;
  padding: 30px 0;
}
.littlewish-part2-content-progress {
  position: relative;
}
.littlewish-part2-content-progress-bg {
  position: absolute;
  left: 5%;
  width: 90%;
  height: 10px;
  background: #f4f9ff;
  border-radius: 10px;
}
.littlewish-part2-content-progress-bar {
  position: absolute;
  left: 5%;
  height: 10px;
  border-radius: 10px;
}
.littlewish-part2-content-status {
  display: flex;
}
.littlewish-part2-content-status-item {
  flex: 1;
  text-align: center;
  padding: 40px 0;
}
.littlewish-part2-content-status-item-money {
  font-size: 21px;
}
.littlewish-part2-content-status-item-label {
  display: block;
  font-size: 14px;
  color: #bdc9d7;
  margin-top: 10px;
}
.littlewish-part2-discription {
  font-size: 19px;
  padding: 50px 0;
}
.littlewish-part3-wrapper {
  border-top: 5px solid #f5f5f5;
  margin-top: 30px;
  padding: 0 20px;
}
.littlewish-part3-label {
  text-align: center;
  font-size: 19px;
  padding: 30px 0;
}
.littlewish-part3-item {
  position: relative;
  background: #ff6867;
  width: 100%;
  /*height:550px;*/
  border-radius: 10px;
  margin-top: 60px;
  margin-bottom: 30px;
}
.littlewish-part3-item-content {
  top: 80px;
  text-align: center;
  color: #fff;
  width: 100%;
  font-size: 28px;
}
.littlewish-part3-item-content-money {
  font-size: 48px;
  padding-right: 4px;
}
.littlewish-part3-item-content-img-wrapper {
  position: absolute;
  top: -54px;
  text-align: center;
  width: 100%;
}
.littlewish-part3-item-content-img {
  width: 108px;
  height: 108px;
  border-radius: 50%;
  border: 1px solid #ff6867;
}
.littlewish-part4-wrapper {
  border-top: 5px solid #f5f5f5;
  padding: 0 20px;
}
.littlewish-part4-label {
  font-size: 18px;
  color: #515151;
  padding-top: 20px;
}
.littlewish-part4-content-item {
  display: flex;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #f4f9ff;
}
.littlewish-part4-content-item-img {
  flex: 0 56px;
  height: 56px;
  width: 56px;
  border-radius: 50%;
}
.littlewish-part4-content-info {
  flex: 1;
  padding-left: 20px;
}
.littlewish-part4-content-info-content {
  height: 30px;
  line-height: 30px;
}
.littlewish-part4-content-info-name {
  font-size: 18px;
  color: #51a3ef;
  padding-right: 8px;
}
.littlewish-part4-content-info-txt {
  font-size: 18px;
}
.littlewish-part4-content-time {
  font-size: 18px;
  color: #cfd7e1;
  margin-top: 10px;
}
.littlewish-part5-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}
.littlewish-part5-item {
  flex: 1;
  text-align: center;
  width: 100%;
}
.littlewish-part5-item-btn {
  cursor: pointer;
  width: 40%;
  height: 42px;
  line-height: 42px;
  border-radius: 10px;
  color: #fff;
  font-size: 18px;
  background: $fontLinear;
  margin: 0 auto;
}
</style>

<style lang="scss">
#homePage {
  .dHtml {
    img {
      width: 400px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/homePage/homePage.vue